<div class="text-center">
    <i class="fa-solid fa-circle-check mt-2 mb-4"></i>
    <h2>Your order has been placed!</h2>
    Here are the details of your order confirmation.<br/><br/>
<label class="medium-text">Order Number:</label> {{state?.orderNumber}}<br/>
<label class="medium-text">Order Date:</label> {{state?.orderedDate | date:'MM/dd/yyyy' }}<br/>
<label class="medium-text">Claim Number:</label> {{state?.claimNumber}}<br/>
<label class="medium-text">Date of Incident:</label> {{state?.incidentDate | date:'MM/dd/yyyy'}}<br/>

</div>
